import { SubscriptionName, SubscriptionPeriod } from '@anm/api/modules/subscription';
import Button from '@anm/components/buttons/Button';
import CardPlan from '@anm/components/subscription/current-plan/CardPlan';
import NextInvoiceBlock from '@anm/components/subscription/current-plan/NextInvoiceBlock';
import SwitchPeriod from '@anm/components/subscription/current-plan/SwitchPeriod';
import { LinkContext } from '@anm/contexts/LinkContext';
import getPeriodName from '@anm/helpers/subscription/getPeriodName';
import isSubscriptionHighPlan from '@anm/helpers/subscription/isHighPlanSubscription';
import { useContext, FC } from 'react';

import { ButtonContainer, CancelButton, CurrentPlanRow } from './Wrapper';
import { calcSaveAmount, getNextPeriodName } from './helpers';

export type CurrentPayPlanProps = {
  period: SubscriptionPeriod;
  planName: string;
  annualPrice: number;
  monthlyPrice: number;
  upgradeRoute: string;
  subscriptionPlan: SubscriptionName;
  nextInvoice?: string;
  nextInvoiceDate?: string;
  onCancel: () => void;
  onPeriodSwitch: (toPeriod: SubscriptionPeriod) => void;
};

const CurrentPayPlan: FC<CurrentPayPlanProps> = ({
  period,
  planName,
  nextInvoice,
  annualPrice,
  nextInvoiceDate,
  monthlyPrice,
  upgradeRoute,
  subscriptionPlan,
  onCancel,
  onPeriodSwitch
}) => {
  const { Link } = useContext(LinkContext);
  const canSwitchPeriod = period !== 'LIFETIME' && subscriptionPlan !== 'WaveStarter';
  const save = period === 'MONTHLY' ? calcSaveAmount(annualPrice, monthlyPrice) : undefined;

  return (
    <CardPlan plan={planName} periodName={getPeriodName(period)}>
      <CurrentPlanRow>
        {nextInvoice && nextInvoiceDate && <NextInvoiceBlock date={nextInvoiceDate} amount={nextInvoice} />}
        {canSwitchPeriod && <SwitchPeriod save={save} toPeriod={getNextPeriodName(period)} onSwitch={onPeriodSwitch} />}
      </CurrentPlanRow>
      <ButtonContainer>
        {!isSubscriptionHighPlan(subscriptionPlan) && (
          <Link route={upgradeRoute}>
            <Button size="medium" variant="light-blue">
              Upgrade
            </Button>
          </Link>
        )}
        <CancelButton size="medium" variant="link" onClick={onCancel}>
          Cancel subscription
        </CancelButton>
      </ButtonContainer>
    </CardPlan>
  );
};

export default CurrentPayPlan;
